import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Server = createReactComponent("Server", ["svg", defaultAttributes, [["rect", {
  x: "2",
  y: "2",
  width: "20",
  height: "8",
  rx: "2",
  ry: "2",
  key: "rx073x"
}], ["rect", {
  x: "2",
  y: "14",
  width: "20",
  height: "8",
  rx: "2",
  ry: "2",
  key: "uf09xm"
}], ["line", {
  x1: "6",
  y1: "6",
  x2: "6.01",
  y2: "6",
  key: "1jphnz"
}], ["line", {
  x1: "6",
  y1: "18",
  x2: "6.01",
  y2: "18",
  key: "1pm8sc"
}]]]);
export default Server;